import { atom } from 'jotai';
import { PHYSICAL_SOURCE } from '@/types/metric';
import { hasMetricTranslation } from '@/utils/metrics';
import { metricDefinitionsAtom } from '../queries/metric';

export const teamMetricsAtom = atom(async get =>
  (await get(metricDefinitionsAtom)).filter(
    metricDefinition => metricDefinition.team && hasMetricTranslation(metricDefinition.key),
  ),
);

export const teamEventMetricsAtom = atom(async get =>
  (await get(teamMetricsAtom)).filter(metricDefinition => metricDefinition.source !== PHYSICAL_SOURCE),
);
